/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Credit_Notes_To_ReviewInputs */

const en_queue_credit_notes_to_review = /** @type {(inputs: Queue_Credit_Notes_To_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit notes to review`)
};

/**
* | output |
* | --- |
* | "Credit notes to review" |
*
* @param {Queue_Credit_Notes_To_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_credit_notes_to_review = /** @type {((inputs?: Queue_Credit_Notes_To_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Credit_Notes_To_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_credit_notes_to_review(inputs)
});